import { instance } from '@/api/instances'

const getStates = async store => {
  if (store.state.locationStates?.length) {
    return store.state.locationStates
  }
  try {
    const response = await instance.get('locations/states')
    store.commit('setStates', response)
    return response
  } catch (error) {
    return []
  }
}

const searchCities = async (_, { stateId, city }) => {
  try {
    return await instance.get(`locations/states/${stateId}/cities?q=${city}`)
  } catch (error) {
    return []
  }
}

export default {
  getStates,
  searchCities
}
